import { Action } from 'redux';

export interface DashboardState {
  loading: boolean;
  panelsData: any;
}

export enum DashboardActionTypes {
  GET_PANELS_DATA_START = '@@dashboard/GET_PANELS_DATA_START',
  GET_PANELS_DATA_SUCCESS = '@@dashboard/GET_PANELS_DATA_SUCCESS',
  GET_PANELS_DATA_ERROR = '@@dashboard/GET_PANELS_DATA_ERROR',
}

export interface DashboardAction extends Action<DashboardActionTypes> {
  panelsData?: any;
}
